module.exports = __webpack_public_path__ + "img/accruedAdmin.113c6f43.svg";